<template>
  <div class="main" ref="main" @click="clickBody">
    <topBar></topBar>
    <navBar v-if="false"></navBar>
    <router-view :key="route.fullPath"></router-view>
    <transition name="el-fade-in-linear">
      <div class="scrollBox" v-show="isShow" @click="goTop">
        <img src="@/assets/commonPc/backToTop.png" class="back-img">
      </div>
    </transition>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from "vue";

import topBar from "@/components/topBar.vue";
import navBar from "@/components/navBar.vue";
import {eventBus} from "@/util/eventBus";
import {useRoute} from "vue-router";
const route = useRoute()

const main = ref(null)
const isShow = ref(false)
const isScrolling = ref(false)

//点击body
const clickBody = () => {
  eventBus.emit('clickBody')
}
//返回顶部事件
const goTop = () => {
  if (isScrolling.value) return;

  const startPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  let startTime = null;
  const duration = 500;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);

    const ease = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    window.scrollTo(0, startPosition * (1 - ease));

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      window.scrollTo(0, 0);
      isScrolling.value = false;
    }
  }

  isScrolling.value = true;
  requestAnimationFrame(animation);
}
//监听滚动条
const handleScroll = () => {
  const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  isShow.value = scrollTop > 400
}
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
})
</script>

<style lang="scss" scoped>
.main {
  min-height: 100vh;
  //overflow-y: auto;
  background: #f4f5f7;
  display: flex;
  flex-direction: column;

  .scrollBox {
    width: 80px;
    height: 80px;
    position: fixed;
    right: 52px;
    bottom: 155px;
    z-index: 99;
    cursor: pointer;

    .back-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
</style>
